
  //import {Vue} from "vue-property-decorator";
  //import Component from "vue-class-component";
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  //import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  
  @Component({
    name: "FormEdit",
  })
  
  export default class FormEdit extends Vue {
    @Prop() tratamiento_selected!: any
    @Prop() swEditar!: boolean

    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public dialog = false;
    $refs!: {
      form: HTMLFormElement,
    };
    
    tratamiento= {
        id: null,
        nombre: '',
        descripcion: '',
        costo: null,
        duracion_estimada: '',
        color: '',
        especialidad_id: null
    }
    valid = true;
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
    
    get especialidades(): any {
      return this.consultorioStore.especialidades;
    }
    mounted(){
      this.cargarDatos();
      this.dialog = this.swEditar
    }

    close(){
      this.dialog=false;
    }
    
    guardar(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Lene todos los campos obligatorios (*)`)
          return;
        }
      
    Alert.confirm(`Se realizará la modificacion del tratamiento`, 'Modificar tratamiento?').then(async result => {
        if(result.isConfirmed){
        await this.consultorioService.updateTratamiento(this.tratamiento)
        this.limpiar()
        this.$emit('close')
        this.$emit('listar')
        }
    })
    
      
    }
    
    cargarDatos(){
        this.tratamiento.id = this.tratamiento_selected.id;
        this.tratamiento.nombre = this.tratamiento_selected.nombre;
        this.tratamiento.descripcion = this.tratamiento_selected.descripcion;
        this.tratamiento.costo = this.tratamiento_selected.costo;
        this.tratamiento.duracion_estimada = this.tratamiento_selected.duracion_estimada;
        this.tratamiento.color = this.tratamiento_selected.color?this.tratamiento_selected.color:'';
        this.tratamiento.especialidad_id = this.tratamiento_selected.especialidad_id?this.tratamiento_selected.especialidad_id:'';

    }
    limpiar(){
      this.tratamiento= {
        id: null,
        nombre: '',
        descripcion: '',
        costo: null,
        duracion_estimada: '',
        color: '',
        especialidad_id: null
    }
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
   
  }
  
  